import { useTranslation } from 'react-i18next';

import { FormGenerator } from '@/shared/ui';
import { Dialog, TDialogBase } from '@/shared/ui/Dialog';
import { Form } from '@/shared/ui/Form';
import { FormFieldValues } from '@/shared/ui/FormGenerator';
import { Button } from '@/shared/ui/lib/Button';

import { companyNameSchema } from '../model/schemas';
import { CreateCompanyFormValues } from '../model/types';
import { useCreateCompany } from '../model/useCreateCompany';

type CreateCompanyDialogProps = TDialogBase & {
  onCreated?: () => void;
};

const CREATE_COMPANY_FORM = 'createCompanyForm';
const CREATE_COMPANY_DIALOG = 'createCompanyDialog';

export const CreateCompanyDialog = ({
  open,
  onClose,
  onCreated,
}: CreateCompanyDialogProps) => {
  const { t } = useTranslation();

  const { createCompany, ...mutationData } = useCreateCompany();

  const formScheme = [
    {
      name: 'name',
      label: t('company:inputs.createCompany'),
      type: FormFieldValues.Default,
    },
  ];

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleCreate = async (data: CreateCompanyFormValues) => {
    await createCompany(data, () => {
      onCreated?.();
    });
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      id={CREATE_COMPANY_DIALOG}
      title={t('company:dialogTitle')}
      leftButtonSlot={
        <Button variant="outlined" onClick={handleClose}>
          {t('common:buttons.cancel')}
        </Button>
      }
      rightButtonSlot={
        <Button
          variant="contained"
          type="submit"
          form={CREATE_COMPANY_FORM}
          loading={mutationData.isPending}
        >
          {t('company:buttons.create')}
        </Button>
      }
    >
      <Form<CreateCompanyFormValues>
        onSubmit={handleCreate}
        schema={companyNameSchema(t)}
        defaultValues={{ name: '' }}
        mode="onChange"
        id={CREATE_COMPANY_FORM}
        mutation={mutationData}
        sx={{ width: '400px' }}
      >
        <FormGenerator formScheme={formScheme} />
      </Form>
    </Dialog>
  );
};
